<template>
	<div>
		waiting ....
	</div>
</template>

<script>
import Oidc from "oidc-client";
export default {
	name: "SilentRenew",
	mounted() {
		new Oidc.UserManager().signinSilentCallback();
	}
};
</script>
